(() => {
  const initialized = new WeakSet();

  function setup(root) {
    if (initialized.has(root)) return;
    initialized.add(root);

    const triggers = [...root.querySelectorAll('[data-te-menu-trigger]')];
    const panels = [...root.querySelectorAll('[data-te-menu-panel]')];
    let closeTimer;
    let activeTrigger = null;

    function alignBrandPanel() {
      const trigger = triggers.find((item) => item.dataset.teMenuTrigger === 'brand');
      const panel = panels.find((item) => item.dataset.teMenuPanel === 'brand');
      if (!trigger || !panel || panel.hidden) return;

      const rootRect = root.getBoundingClientRect();
      const triggerRect = trigger.getBoundingClientRect();
      const panelWidth = panel.getBoundingClientRect().width;
      const inset = 16;
      const left = Math.max(inset, Math.min(triggerRect.left - rootRect.left, rootRect.width - panelWidth - inset));
      panel.style.left = `${left}px`;
    }

    function close() {
      clearTimeout(closeTimer);
      panels.forEach((panel) => { panel.hidden = true; });
      triggers.forEach((trigger) => { trigger.setAttribute('aria-expanded', 'false'); });
      activeTrigger = null;
    }

    function open(trigger) {
      if (!matchMedia('(min-width: 1024px)').matches) return;
      const panel = panels.find((item) => item.dataset.teMenuPanel === trigger.dataset.teMenuTrigger);
      if (!panel) return;
      clearTimeout(closeTimer);
      panels.forEach((item) => { item.hidden = item !== panel; });
      triggers.forEach((item) => { item.setAttribute('aria-expanded', String(item === trigger)); });
      activeTrigger = trigger;
      if (trigger.dataset.teMenuTrigger === 'brand') alignBrandPanel();
    }

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        open(trigger);
      });
      trigger.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowDown') return;
        open(trigger);
        const panel = panels.find((item) => item.dataset.teMenuPanel === trigger.dataset.teMenuTrigger);
        const firstLink = panel?.querySelector('a');
        if (firstLink) {
          event.preventDefault();
          firstLink.focus();
        }
      });
      trigger.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') open(trigger);
      });
    });

    root.querySelectorAll('.te-quick-nav > a').forEach((link) => {
      link.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') close();
      });
      link.addEventListener('focus', close);
    });

    root.addEventListener('pointerleave', (event) => {
      if (event.pointerType === 'mouse') closeTimer = setTimeout(close, 180);
    });
    root.addEventListener('pointerenter', () => clearTimeout(closeTimer));
    root.addEventListener('focusout', (event) => {
      if (!root.contains(event.relatedTarget)) close();
    });
    root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && activeTrigger) {
        const trigger = activeTrigger;
        close();
        trigger.focus();
      }
    });
    document.addEventListener('pointerdown', (event) => {
      if (!root.contains(event.target)) close();
    });
    window.addEventListener('resize', () => {
      if (!matchMedia('(min-width: 1024px)').matches) close();
      else if (activeTrigger?.dataset.teMenuTrigger === 'brand') alignBrandPanel();
    });

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:block:select', (event) => {
        if (!root.contains(event.target)) return;
        const selected = event.target.closest('[data-te-block-id], [data-te-menu-trigger]');
        const panel = selected?.closest('[data-te-menu-panel]');
        const key = panel?.dataset.teMenuPanel || selected?.dataset.teMenuTrigger;
        const trigger = triggers.find((item) => item.dataset.teMenuTrigger === key);
        if (trigger) open(trigger);
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-te-mega-root]').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
